import axios from "axios";
import { APIURL } from "./../Constantes";
import { getCabecera } from "../utils/getCabecera";
// import { getError } from "../utils/errors";

const urlNotification = "Notification";

export const getNotifiacionesPaquete = async ({ idPaquete }) => {
    return axios.get(`${APIURL}/${urlNotification}/Pacakage/${idPaquete}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}

export const getNotifiacionesClientePaquete = async ({ idCuenta, idPaquete }) => {
    return axios.get(`${APIURL}/${urlNotification}/Pacakage/${idCuenta}/${idPaquete}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}
